@if (inputControl) {
  <mat-form-field class="full-width" floatLabel="always" subscriptSizing="dynamic">
    <mat-label></mat-label>
    <mat-chip-grid #chipList [disabled]="disabled">
      @for (item of selected; track item) {
        <mat-chip-row (removed)="remove(item)">
          {{ item }}
          <button matChipRemove> <mat-icon>cancel</mat-icon> </button>
        </mat-chip-row>
      }
      <input type="text" #inputTrigger matInput [formControl]="inputControl" [placeholder]="inputPlaceholder"
        [matAutocomplete]="autoComplete" [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addFreeTextItem($event)"
        (mousedown)="markAsTouched()">
      </mat-chip-grid>
      <mat-autocomplete #autoComplete="matAutocomplete" (optionSelected)="optionSelected($event)">
        @for (item of filteredItems; track item) {
          <mat-option [value]="selected">
            {{ item }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  }
  @if (!isValid && inputControl?.touched) {
    <div class="error">
      At lease 1 item must be set
    </div>
  }